import type { Project, SimpleProject } from '@meego/models/src/types/base';

import storageManager from './core';

export const MainProjectLocalKey = 'leopard-default-project';

export class ProjectUtil {
  static changeCurrentProject(value?: SimpleProject | Project) {
    storageManager.setLocal(MainProjectLocalKey, JSON.stringify(value));
  }

  static getProjectFromCache() {
    try {
      return JSON.parse(storageManager.getLocal(MainProjectLocalKey) ?? '""');
    } catch {
      return undefined;
    }
  }
}
